import { useContext, useEffect } from 'react';

import {
  getSearchRandomizedFeedState,
  SearchRandomizedFeedsContext,
} from './searchRandomizedFeeds.context';

export default function useSearchRandomizedFeed({
  feedKey,
  endpoint,
  limitParam,
  limit,
  enabled = true,
  injectToken = false,
  optionalToken = true,
  errorMessage = 'Unable to refresh content at the moment.',
}) {
  const context = useContext(SearchRandomizedFeedsContext);
  if (!context) {
    throw new Error('useSearchRandomizedFeed must be used within SearchRandomizedFeedsProvider.');
  }

  const { feeds, loadFeed } = context;
  const feed = getSearchRandomizedFeedState(feeds, feedKey);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    void loadFeed({
      feedKey,
      endpoint,
      limitParam,
      limit,
      injectToken,
      optionalToken,
      errorMessage,
    });
  }, [enabled, endpoint, errorMessage, feedKey, injectToken, optionalToken, limit, limitParam, loadFeed]);

  if (enabled && !feed.hasRequested) {
    return { ...feed, loading: true };
  }

  return feed;
}
